<template>
  <div id="Product">
    <div class="banner">
      <img src="/static/images/product/pd_bg.png" alt="">
      <div class="con">
        <div class="bannerText">Lettuce Software</div>
        <div class="conBox" v-for="(item,index) in list" :key="index">
          <div class="imgBox">
            <img :src="item.src" alt="">
          </div>
          <div class="proInfo">
            <div class="proName">{{item.proName}}</div>
            <div class="proDetail">{{item.proDetail}}</div>
            <div class="proPrice">
              <div>
                <span class="price">Price: ₱ {{item.price}}</span>
              </div>
              <div class="servceFree" v-if="item.servicePrice">
                <span class="price">Service fee：₱ {{item.servicePrice}}/Month</span>
              </div>
            </div>
            <!-- <div class="proBtn">{{item.proBtn}}</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="content">
        <div class="con">
          <div class="title">Hardware cost</div>
          <div class="productBox">
            <div class="proList"  v-for="(item,index) in proList" :key="index">
              <div class="proImg"><img :src="item.src" alt=""></div>
              <div class="proCon">
                <div class="proName">{{item.proName}}</div>
                <div class="proDetail">{{item.proDetail}}</div>
                <div class="proPrice">
                  <span class="price">{{item.price}}</span>
                  <!-- <span class="proBtn">{{item.proBtn}}</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list:[
        {
          src:'/static/images/product/pd_pos.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'25000.00',
          servicePrice:'1000.00',
        },
        {
         src:'/static/images/product/pd_ipad.png',
          proName:'Take Order Machine',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'15000.00',
          servicePrice:'1000.00',
        },
        {
         src:'/static/images/product/pd_web.png',
          proName:'Take Order Machine',
          proDetail:'Business data online viewing, quick configuration of store information',
          price:'50000.00',
          servicePrice:'',
        }
      ],
        proList:[
        {
          src:'/static/images/product/pd_a.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month',
          proBtn:'Booking'
        },
        {
         src:'/static/images/product/pd_b.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month',
          proBtn:'Booking'
        },
        {
         src:'/static/images/product/pd_c.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month',
          proBtn:'Booking'
        },
        {
         src:'/static/images/product/pd_d.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month',
          proBtn:'Booking'
        },
        {
         src:'/static/images/product/pd_e.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month',
          proBtn:'Booking'
        },
        {
         src:'/static/images/product/pd_f.png',
          proName:'Cashier POS',
          proDetail:'Frequently asked questions about catering software for everyday use',
          price:'₱ 1680.00',
          unit:'P/Month',
          proBtn:'Booking'
        },
      ],
      selectId:0
    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
    clickList(id){
      this.selectId = id
    },
  }
};
</script>
<style scoped lang="less" type="text/less">
#Product{
  margin-top: 65px;
  .banner{
    position: relative;
    img{
      width: 100%;
      max-height: 1000px;
    }
    .con{
      position: absolute;
      width: 60%;
      top: 8%;
      left: 0;
      right: 0;
      margin: auto;
      .bannerText{
        text-align: center;
        color: #333;
        font-size: 30px;
        font-weight: bold;
        padding-bottom: 60px;
      }
      .conBox{
        display: flex;
        justify-content: center;
        align-items: center;
        // padding: 20px 0;
        &:nth-child(2){
          padding-bottom: 0;
          // border-bottom: 1px solid #d6d6d6;
        }
        .imgBox{
          // width: 30%;
          text-align: center;
          img{
            width: 80%;
          }
        }
        .proInfo{
          // width: 70%;
          .proName{
            color: #333;
            font-size: 24px;
            font-weight: bold;
          }
          .proDetail{
            padding: 15px 0;
            font-size: 16px;
            color: #999;
          }
          .proPrice{
            position: relative;
            .price{
              font-size: 24px;
              font-weight: bold;
              color: #FF9703;
            }
            .unit{
              font-size: 14px;
              font-weight: bold;
              color: #FF9703;
            }
            .servceFree{
              .price{
                font-size: 18px;
                font-weight: bold;
                color: #25B7AA;
              }
              .unit{
                font-size: 12px;
                font-weight: bold;
                color: #25B7AA;
              }
            }
          }

          .proBtn{
            background:rgba(39,194,180,1);
            box-shadow:0px 3px 6px rgba(11,128,117,0.26);
            border-radius:18px;
            display: inline-block;
            padding: 6px 20px;
            color: #fff;
            font-size: 16px;
            margin-top: 10px;
            // position:absolute;
            // right: 0;
            cursor: pointer;
          }
        }
      }

    }
  }
  .content{
    padding: 60px 0;
    .con{
      width: 60%;
      margin: 0 auto;
      .title{
        color: #333;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        padding:0 0 50px 0;
      }
      .productBox{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        .proList{
          width: 32.4%;
          margin: 0 1% 2% 0;
          border: 1px solid #ededed;
          &:nth-child(3n){
            margin-right: 0;
          }
          .proImg{
            img{
              width: 100%;
            }
          }
          .proCon{
            padding: 20px;
            .proName{
              font-size: 20px;
              color: #333;
              font-weight: bold;
            }
            .proDetail{
              color: #999;
              font-size: 14px;
              padding: 10px 0;
              // border-bottom: 1px solid #ededed;
            }
            .proPrice{
              position: relative;
              .price{
                color: #FF9703;
                font-size: 20px;
                font-weight: bold;
              }
              .proBtn{
                background:rgba(39,194,180,1);
                box-shadow:0px 3px 6px rgba(11,128,117,0.26);
                border-radius:18px;
                display: inline-block;
                padding: 8px 15px;
                color: #fff;
                font-size: 14px;
                position:absolute;
                right: 0;
                top: 15px;
                cursor: pointer;
              }

            }
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/Product.vue